export default __webpack_public_path__ + "62d5a492d4f31062c04891a847a03f53.png";